import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ReactivosComponent } from './reactivos.component';
import { AuthGuard } from 'app/auth/auth.guard';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import {MatExpansionModule} from '@angular/material/expansion';

import { MatTabsModule } from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
import {CdkStepperModule} from '@angular/cdk/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatRadioModule } from '@angular/material/radio';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseConfirmDialogModule, FuseSidebarModule,FuseWidgetModule } from '@fuse/components';





import { TraduccionReactivosComponent } from './traducciones/traduccionreactivos.component';
import { PreviewReactivosComponent } from './preview/reactivospreview.component';
import { NativeComponent } from './native/native.component';

const rutas: Routes = [
  {
    path: 'reactives',
    component: ReactivosComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [ReactivosComponent,NativeComponent,TraduccionReactivosComponent,PreviewReactivosComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatStepperModule,
    CdkStepperModule,

    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatRippleModule,
    MatTableModule,
    MatSelectModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatCardModule,
    MatButtonToggleModule,
    BrowserModule,
    BrowserAnimationsModule,
    DragDropModule,
    MatRadioModule,
    FuseSharedModule,
    FuseConfirmDialogModule,
    FuseSidebarModule,
    MatExpansionModule,
    FuseWidgetModule
  ]
})
export class ReactivosMT5Module { }
